export default __webpack_public_path__ + "img/rank3-396e3cf9.png";